<template>
  <section class="flex-col" >
    <h2 id="how-it-works-heading">{{ title }}</h2>
    <p v-if="subHeading" class="subHeading">{{ subHeading }}</p>

    <div class="content">
      <ol class="steps-container" :style="{ backgroundColor: colors.navBg }" aria-label="Steps">
        <li v-for="(step, index) in steps" :key="index" class="step" :style="{ backgroundColor: colors.primaryBg }"
          >
          <div class="icon-container" :style="{ backgroundColor: colors.navBg }" aria-hidden="true" v-html="step.icon">
          </div>

          <div>
            <b :style="{ color: colors.primaryText }">{{ step.title }}</b>
            <p>{{ step.description }}</p>
          </div>
        </li>
      </ol>

      <img :src="imageSrc" class="img-fluid" :alt="imageAlt" />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import { useTheme } from "~/composables/useTheme";

type HowItWorksStep = {
  title: string;
  description: string;
  icon: string; // SVG markup string
};

export default defineComponent({
  name: "HomeHowItWorks",
  props: {
    title: { type: String, default: "How EquiRize Works?" },
    subHeading: { type: String, default: "Fixed income investment, simplified for you." },
    imageSrc: { type: String, default: "/images/how-it-works-light.webp" },
    imageAlt: { type: String, default: "" },
    steps: { type: Array as PropType<HowItWorksStep[]>, default: () => [] },
  },
  setup() {
    const { colors } = useTheme();
    return { colors };
  },
});
</script>
<style scoped>
.content {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.steps-container {
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 26px;
}

.step {
  display: flex;
  align-items: center;
  padding: 20px 10px;
  ;
  gap: 20px;
  border-radius: 14px;
}

.icon-container {
  display: flex;
  padding: 1%;
  border-radius: 5px;
}

@media (min-width: 1024px) {
  .content {
    width: 80%;
    flex-direction: row;
    align-items: center;
    gap: 100px;
  }

  .steps-container {
    padding: 40px;
  }

  .img-fluid {
    min-width: 500px;
  }
}
</style>